/**
 * Created by woo on 01/06/2017.
 */

import React, { Component } from 'react'
// import style from './style.css';

export default class extends Component {
  render() {
    return (
      <div className="NotFound">
        <h1>Not Found</h1>
      </div>
    )
  }
};




// WEBPACK FOOTER //
// ./src/containers/NotFound/index.js